import { render, staticRenderFns } from "./DepositsTableDialog.vue?vue&type=template&id=71719642&"
import script from "./DepositsTableDialog.vue?vue&type=script&lang=ts&"
export * from "./DepositsTableDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports